export default function SwitchButton({
  checked,
  onChange,
  disabled,
}: {
  checked: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
}) {
  return (
    <button
      type="button"
      onClick={() => !disabled && onChange(!checked)}
      disabled={disabled}
      className={`w-9 h-5 flex items-center rounded-full transition ${
        checked ? 'bg-blue-500' : 'border border-gray-400'
      } ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
    >
      <div
        className={`w-3 h-3 rounded-full transform transition ${
          checked ? ' bg-white translate-x-5' : ' bg-gray-400 translate-x-1'
        }`}
      />
    </button>
  );
}
